import { Button } from "react-bootstrap";
import { ExecutionActions } from "./ExecutionModal";

const ObjectSelectionConfirmationBox = ({
  selectedObjects,
  onConfirm,
  onCancel,
  title,
  style,
}) => {
  return (
    <div className={"execution-cta-container"} style={style}>
      <div className="flex flex-col">
        {title && <span>{title}</span>}
        <ExecutionActions align="center">
          <Button
            variant="success"
            onClick={() => {
              onConfirm(selectedObjects);
            }}
            disabled={selectedObjects.length === 0}
          >
            Confirm ({selectedObjects.length} Objects)
          </Button>

          {onCancel && (
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
          )}
        </ExecutionActions>
      </div>
    </div>
  );
};

export default ObjectSelectionConfirmationBox;
